import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeSaleDateCommand extends BaseCommand {
  CommandName = "ChangeSaleDate";
  Command: {
    Date: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, date: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Date: date };
  }
}
